import { FormattedMessage } from "react-intl";
import { graphql } from "relay-runtime";
import { useMutation } from "react-relay";
import { LogoutButtonMutation as LogoutButtonMutationType } from "./__generated__/LogoutButtonMutation.graphql";
import { useLocation } from "../utils/location";
import { logger } from "../common/logger";
import { Button } from "@/kit/ui/button";
import { LogOut04Icon } from "@/icons";
import { usePostHog } from "@posthog/react";

const REDIRECT_LANDING = import.meta.env.VITE_REDIRECT_LANDING;

const LogoutButtonMutation = graphql`
  mutation LogoutButtonMutation {
    logoutUser
  }
`;

export default function LogoutButton() {
  const location = useLocation();
  const posthog = usePostHog();
  const [commitMutation, isMutationInFlight] =
    useMutation<LogoutButtonMutationType>(LogoutButtonMutation);
  const onSubmit = () => {
    commitMutation({
      variables: {},
      onError(err) {
        logger.error(err);
      },
      onCompleted() {
        posthog.reset(true); // https://posthog.com/docs/getting-started/identify-users#3-reset-after-logout
        location.assign(REDIRECT_LANDING ? REDIRECT_LANDING : "/");
      },
    });
  };
  return (
    <Button
      type="button"
      variant="secondary"
      onClick={onSubmit}
      disabled={isMutationInFlight}
      className="w-full"
    >
      <FormattedMessage defaultMessage="Log out" />
      <LogOut04Icon className="w-5 h-5" />
    </Button>
  );
}
